// extracted by mini-css-extract-plugin
module.exports = {"inline":"tooltip-icon_inline__2XXL5","icon-small":"tooltip-icon_icon-small__3Pq-V","tooltip-icon":"tooltip-icon_tooltip-icon__dctjD"};